












import {Vue, Component, Prop, Watch} from 'vue-property-decorator';

@Component({
    components: {},
})
export default class RotatingHeader extends Vue {
    @Prop({default: 0})
    public value!: number;
    @Prop({default: () => []})
    public items!: string[];

    public enabled: boolean = false;
    private direction = true;

    @Watch('value')
    public onValueChanged(value: number, oldValue: number) {
        this.direction = value > oldValue;
    }

    public prev() {
        this.$emit('value', this.value - 1);
    }

    public next() {
        this.$emit('value', this.value + 1);
    }
}
